<template>
  <div class="top-bar" :class="{ 'gray-background': logEntries.length == 0  }">
    <button @click="open = !open" class="dropdown-toggle" :class="[
    'dropdown-toggle',
    {
      'gray-background': logEntries.length === 0,
      'default-background': logEntries.length > 0
    }
  ]">
      Warning ({{ logEntries.length }}) 
      <span>{{ open ? '▲' : '▼' }}</span>
    </button>

    <div v-if="open" class="dropdown-list" :class="[
    {
      'gray-theme': logEntries.length === 0,
      'default-theme': logEntries.length > 0
    }
  ]">
      <template v-if="logEntries.length > 0">
        <button @click="clearLog" class="clear-button">Clear</button>

        <div 
          class="telemetry-item"
          v-for="(entry, index) in logEntries"
          :key="index">
          <label class="need-space"><strong>{{ entry.topic }}:</strong></label> 
          <label class="need-space">{{ entry.value }}</label> 
          <label class="need-space">at</label>{{ entry.time }}
        </div>
      </template>

      <template v-else>
        <div class="no-data">No critical data</div>
      </template>
    </div>
  </div>
</template>

<style scoped>
.top-bar.gray-background {
  background-color: rgb(32, 30, 30);
  border-bottom: 0.5px solid #444444;
}

.dropdown-toggle:hover{
  background-color: rgb(32, 30, 30);
}

.default-background:hover{
  background-color: rgb(137, 0, 0);
}

.gray-theme{
  background-color: #444444;
}

.default-theme{
  background-color: rgb(90, 0, 0);
}

</style>

<script setup>
import { ref, computed, watch } from 'vue'
import { useStore } from 'vuex'
import '../assets/scss/desktop/components/_warning_bar.scss'

const store = useStore()
const open = ref(false)
const data = computed(() => store.state.data)

const logEntries = ref([])
const lastLoggedValues = ref({})

watch(data, (newData) => {
  for (const [topic, value] of Object.entries(newData)) {
    const isCellVoltage = topic.includes('Cell_Voltage_');
    const isCellTemp = topic.includes('Cell_Temperature_');
    const isTyreTemp = topic.includes('Tyre_Temp_');

    const isInteresting =
      (topic === 'Vehicle_speed' && value > 100) ||
      (topic === 'RPM' && value > 10000) ||
      (topic === 'ThrottlePosition' && value > 60) ||
      (topic === 'FrontBrakePressure' && value > 60) ||
      (topic === 'BreakTempFront' && value > 100) ||
      (topic === 'BreakTempRear' && value > 100) ||
      (isCellVoltage && value > 120) ||
      (isCellTemp && value > 60) ||
      (isTyreTemp && value > 85) 

    if (isInteresting && lastLoggedValues.value[topic] !== value) {
      const timestamp = Date.now();
      const date = new Date(timestamp);

      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');
      const formattedTime = `${hours}:${minutes}:${seconds}`;

      logEntries.value.push({ topic, value, time: formattedTime })
      lastLoggedValues.value[topic] = value
    }

    console.log(logEntries.length,'qwe')
  }
  //console.log(document.getElementsByClassName('telemetry-item').length,'asd');

  /*let x = document.getElementsByClassName('telemetry-item');
  console.log(x,'asd');
  for (const element of x) {
    console.log(element);
  }*/
}, { deep: true })

function clearLog() {
  logEntries.value = []
  lastLoggedValues.value = {} 
}
</script>


